<template>
    <section class="page-cabinet-intelinvest">
        <h1 class="page-cabinet-intelinvest__title">Интелинвест</h1>
        <div class="page-cabinet-intelinvest__content" v-if="!isLoading">
            <div class="page-cabinet-intelinvest__description">
                Для того, чтобы подключиться к Интелинвест, сгенерируйте код доступа по кнопке ниже. Скопируйте его и вставьте на сайте Интелинвест.<br>
                Если вы отзываете код, то данные перестанут отправляться в Интелинвест.
            </div>

            <ui-card-base v-if="!currentToken">
                <div class="page-cabinet-intelinvest__data">
                    <div class="page-cabinet-intelinvest__data-button">
                        <ui-button
                            v-on:click="addToken"
                            v-bind:disabled="isLoading"
                            text="Cгенерировать код"
                        />
                    </div>
                </div>
            </ui-card-base>

            <ui-card-base v-if="currentToken">
                <div class="page-cabinet-intelinvest__data">
                    <div class="page-cabinet-intelinvest__data-link">
                        {{ currentToken.token || (currentToken.tokenPrefix + ' ***') }}
                    </div>
                    <div class="page-cabinet-intelinvest__data-button">
                        <ui-button
                            v-bind:disabled="isCopyInProgress"
                            v-on:click="copyLink"
                            text="Копировать"
                            v-if="currentToken.token"
                        />
                        <ui-button
                            v-on:click="revokeToken"
                            v-bind:disabled="isLoading"
                            theme="transparent"
                            text="Отозвать код"
                        />
                    </div>
                </div>
            </ui-card-base>

            <div class="page-cabinet-intelinvest__error" v-if="error">{{ error }}</div>
        </div>
        <transition name="fade">
            <ui-block-loader v-if="isLoading || !user" />
        </transition>
    </section>
</template>

<script>
import utils from '~/utils';
import { mainClient } from '~/network';

export default {
    name: 'page-cabinet-intelinvest',
    data: () => ({
        isIE: utils.environments.isIE(),
        isCopyInProgress: false,
        isLoading: false,
        tokens: [],
        newToken: null,
        error: 'Тестовая ошибка',
    }),
    computed: {
        user() {
            return this.$store.getters['users/user'];
        },
        validTokens() {
            return this.tokens.filter((token) => token.isActive);
        },
        currentToken() {
            return this.newToken ?? this.validTokens[0];
        },
    },
    methods: {
        async getTokens() {
            this.error = null;
            this.isLoading = true;
            try {
                const { data, error } = await mainClient.intelinvest.requests.getIntelinvestTokens();
                if (!error && data && Array.isArray(data)) {
                    this.tokens = data;
                }
            } catch (e) {
                this.error = 'Не удалось загрузить токен. Попробуйте обновить страницу';
                console.error(e);
            }
            this.isLoading = false;
        },
        async addToken() {
            this.error = null;
            this.isLoading = true;
            try {
                const { data, error } = await mainClient.intelinvest.requests.createIntelinvestToken();
                if (!error && data) {
                    this.newToken = data;
                }
            } catch (e) {
                this.error = 'Не удалось выпустить токен. Попробуйте еще раз';
                console.error(e);
            }
            await this.getTokens();
        },
        async revokeToken() {
            this.error = null;
            this.isLoading = true;
            try {
                for (const token of this.validTokens) {
                    await mainClient.intelinvest.requests.removeIntelinvestToken({ id: token.id });
                }
                this.newToken = null;
            } catch (e) {
                this.error = 'Не удалось отозвать токен. Попробуйте еще раз';
                console.error(e);
            }
            await this.getTokens();
        },
        copyLink() {
            this.isCopyInProgress = true;
            navigator.clipboard.writeText(this.currentToken?.token ?? '').then(() => {
                this.isCopyInProgress = false;
            });
        },
    },
    mounted() {
        this.getTokens();
    },
};
</script>

<style scoped lang="less">
@import '~theme';

.page-cabinet-intelinvest {
    position: relative;
    width: 100%;
    min-height: 100%;

    &__title {
        .typography-heading();

        margin-bottom: 24px;
    }

    &__description {
        .typography-body();
    }

    &__content {
        display: flex;
        flex-direction: column;
        gap: 8px;

        &-cards {
            display: none;
        }

        @media @media-md-down {
            &-table {
                display: none;
            }
            &-cards {
                display: block;
            }
        }
    }

    &__data {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        width: 100%;
        &-link {
            .typography-heading();

            flex: 1 1 auto;

            word-break: break-all;
        }
        &-button {
            display: flex;
            flex-direction: row;
            flex: 0 0 auto;
            margin-left: 40px;
        }
    }

    &__error {
        color: @color-accent-negative;
    }

    @media @media-sm-down {
        &__data {
            display: block;
            &-button {
                flex-direction: column;
                width: 100%;
                margin-left: 0;
                margin-top: 16px;
            }
        }
    }
}
</style>
